import { initializeApp } from "firebase/app";
import { getFunctions ,httpsCallable} from "firebase/functions";
import { getAnalytics} from "firebase/analytics";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const firebaseApp = initializeApp(firebaseConfig);
// Firebase Functionsを取得
const functions = getFunctions(firebaseApp);
const analytics = getAnalytics(firebaseApp);
export { firebaseApp, functions , httpsCallable, analytics };
